import FileSaver from "file-saver";
export class EdelFileSaver {
    saveFile(file) {
        FileSaver.saveAs(file);
    }
}
